module.exports = __webpack_public_path__ + "media/images/icons/flags/ML-c5195280d34fb49f1e9ae7e7a0f4f22b.svg";